var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeAlarmEditor,
          expression: "closeAlarmEditor"
        }
      ],
      staticClass: "property-alarm-item"
    },
    [
      _c("div", { staticClass: "property-alarm-item__icon" }, [
        _c("div", { staticClass: "icon", class: _vm.icon })
      ]),
      _vm._v(" "),
      !_vm.isEditing
        ? _c("div", { staticClass: "property-alarm-item__label" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(
                  _vm._f("formatAlarm")(
                    _vm.alarm,
                    _vm.isAllDay,
                    _vm.currentUserTimezone,
                    _vm.locale
                  )
                ) +
                "\n\t"
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing && _vm.isRelativeAlarm && !_vm.isAllDay
        ? _c(
            "div",
            {
              staticClass:
                "property-alarm-item__edit property-alarm-item__edit--timed"
            },
            [
              _c("input", {
                attrs: { type: "number", min: "0", max: "3600" },
                domProps: { value: _vm.alarm.relativeAmountTimed },
                on: { input: _vm.changeRelativeAmountTimed }
              }),
              _vm._v(" "),
              _c("AlarmTimeUnitSelect", {
                attrs: {
                  "is-all-day": _vm.isAllDay,
                  count: _vm.alarm.relativeAmountTimed,
                  unit: _vm.alarm.relativeUnitTimed,
                  disabled: false
                },
                on: { change: _vm.changeRelativeUnitTimed }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing && _vm.isRelativeAlarm && _vm.isAllDay
        ? _c(
            "div",
            {
              staticClass:
                "property-alarm-item__edit property-alarm-item__edit--all-day"
            },
            [
              _c("input", {
                attrs: { type: "number", min: "0", max: "3600" },
                domProps: { value: _vm.alarm.relativeAmountAllDay },
                on: { input: _vm.changeRelativeAmountAllDay }
              }),
              _vm._v(" "),
              _c("AlarmTimeUnitSelect", {
                attrs: {
                  "is-all-day": _vm.isAllDay,
                  count: _vm.alarm.relativeAmountAllDay,
                  unit: _vm.alarm.relativeUnitAllDay,
                  disabled: false
                },
                on: { change: _vm.changeRelativeUnitAllDay }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("calendar", "before at")) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              _c("TimePicker", {
                attrs: { date: _vm.relativeAllDayDate },
                on: { change: _vm.changeRelativeHourMinuteAllDay }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEditing && _vm.isAbsoluteAlarm
        ? _c(
            "div",
            {
              staticClass:
                "property-alarm-item__edit property-alarm-item__edit--absolute"
            },
            [
              _c("DatePicker", {
                attrs: {
                  prefix: "on",
                  date: _vm.alarm.absoluteDate,
                  "is-all-day": false
                },
                on: { change: _vm.changeAbsoluteDate }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "property-alarm-item__options" },
            [
              _c(
                "Actions",
                [
                  _c(
                    "ActionRadio",
                    {
                      attrs: {
                        name: _vm.alarmTypeName,
                        checked: _vm.isAlarmTypeDisplay
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeType("DISPLAY")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Notification")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ActionRadio",
                    {
                      attrs: {
                        name: _vm.alarmTypeName,
                        checked: _vm.isAlarmTypeEmail
                      },
                      on: {
                        change: function($event) {
                          return _vm.changeType("EMAIL")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Email")) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isAlarmTypeAudio
                    ? _c(
                        "ActionRadio",
                        {
                          attrs: {
                            name: _vm.alarmTypeName,
                            checked: _vm.isAlarmTypeAudio
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeType("AUDIO")
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("calendar", "Audio notification")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isAlarmTypeOther
                    ? _c(
                        "ActionRadio",
                        {
                          attrs: {
                            name: _vm.alarmTypeName,
                            checked: _vm.isAlarmTypeOther
                          },
                          on: {
                            change: function($event) {
                              return _vm.changeType(_vm.alarm.type)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("calendar", "Other notification")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("ActionSeparator"),
                  _vm._v(" "),
                  !_vm.isRecurring
                    ? _c(
                        "ActionRadio",
                        {
                          attrs: {
                            name: _vm.alarmTriggerName,
                            checked: _vm.isRelativeAlarm
                          },
                          on: { change: _vm.switchToRelativeAlarm }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("calendar", "Relative to event")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isRecurring
                    ? _c(
                        "ActionRadio",
                        {
                          attrs: {
                            name: _vm.alarmTriggerName,
                            checked: _vm.isAbsoluteAlarm
                          },
                          on: { change: _vm.switchToAbsoluteAlarm }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("calendar", "On date")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("ActionSeparator"),
                  _vm._v(" "),
                  _vm.canEdit && !_vm.isEditing
                    ? _c(
                        "ActionButton",
                        {
                          attrs: { icon: "icon-edit" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.toggleEditAlarm($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("calendar", "Edit time")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canEdit && _vm.isEditing
                    ? _c(
                        "ActionButton",
                        {
                          attrs: { icon: "icon-checkmark" },
                          on: { click: _vm.toggleEditAlarm }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.$t("calendar", "Save time")) +
                              "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "ActionButton",
                    {
                      attrs: { icon: "icon-delete" },
                      on: { click: _vm.removeAlarm }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.$t("calendar", "Remove reminder")) +
                          "\n\t\t\t"
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }